import type { SVGProps } from "react";
import * as React from "react";
const SvgZapier = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#FF4A00"
      d="M12.006 2c.565.001 1.12.049 1.66.14v5.82l4.128-4.116a10.03 10.03 0 0 1 2.358 2.352l-4.128 4.117h5.838c.09.538.138 1.09.138 1.655v.013c0 .565-.048 1.118-.138 1.656h-5.838l4.128 4.116c-.325.455-.687.881-1.08 1.275h-.001c-.394.393-.82.754-1.276 1.077l-4.128-4.117v5.822a10.18 10.18 0 0 1-1.66.14h-.014a10.178 10.178 0 0 1-1.659-.14v-5.822l-4.127 4.117a10.03 10.03 0 0 1-2.358-2.352l4.128-4.116H2.139A9.92 9.92 0 0 1 2 11.978v-.029c.001-.146.01-.325.024-.51l.005-.056c.04-.521.11-1.07.11-1.07h5.838L3.849 6.196c.323-.455.685-.88 1.079-1.273l.002-.002a9.98 9.98 0 0 1 1.277-1.077l4.127 4.117V2.139A10.18 10.18 0 0 1 11.994 2h.012Zm0 7.481h-.01c-.743 0-1.455.136-2.112.383A5.989 5.989 0 0 0 9.5 11.97v.01c0 .74.137 1.45.385 2.105a5.985 5.985 0 0 0 2.11.383h.01c.743 0 1.455-.136 2.111-.383a5.95 5.95 0 0 0 .384-2.106v-.01c0-.74-.136-1.45-.384-2.105a5.986 5.986 0 0 0-2.11-.383Z"
    />
  </svg>
);
export default SvgZapier;
